import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import TweenedNumber from 'core/ui/tweened-number';
import { humanizeNumber } from './chart-base';
import LabelWithTooltip from './label-with-tooltip';
import DateRangeWidget, { formatDate } from './date-range-widget';

function BirthdateRangeWidget(props) {
  // Today minus 18 years
  function getStartDateFn(formatted) {
    const currDate = new Date();
    const startDate = new Date(currDate.setFullYear(currDate.getFullYear() - 18));
    return formatted ? formatDate(startDate) : startDate;
  }

  function renderChart({
    base, startDate, endDate, startDateMax, modal,
    toggle, onDateChange, onDateCommit, onRemoveDate,
    formatDisplayDateRange, chartValues, ...chartProps
  }) {
    const chartType = chartProps.config.label;
    const shouldTween = chartProps.tween;
    const viewOnly = chartProps.viewOnly;
    const minDate = new Date('January 1, 1925');
    const maxDate = getStartDateFn();
    const dateNote = 'To ensure the targets are adults, the latest date that can be entered is 18 years prior to today\'s date.';

    return (
      <>
        {!viewOnly && (
          <>
            <Button size="sm" className="btn-light" onClick={toggle}>+ Add Date Range</Button>
            <Modal isOpen={modal} toggle={toggle} className="modal-dialog-centered date-picker">
              <ModalHeader toggle={toggle}>{chartType}</ModalHeader>
              <ModalBody>
                <div className='datepicker'>
                  <div className='dp-start'>
                    <label>Start Date</label>
                    <DatePicker
                      startDate={startDate}
                      selected={startDate || maxDate}
                      onChange={(ev, startDate) => onDateChange(ev, startDate, 'start')}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      minDate={minDate}
                      maxDate={startDateMax || maxDate}
                    >
                      <div className='date-note'>{dateNote}</div>
                    </DatePicker>
                  </div>
                  <div className='dp-end'>
                    <label>End Date</label>
                    <DatePicker
                      endDate={endDate}
                      selected={endDate}
                      onChange={(ev, endDate) => onDateChange(ev, endDate, 'end')}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      minDate={startDate || minDate}
                      maxDate={maxDate}
                    >
                      <div className='date-note'>{dateNote}</div>
                    </DatePicker>
                  </div>
                </div>
                <p className="small">{dateNote}</p>
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" size="sm" onClick={toggle}>Cancel</Button>
                <Button color="primary" className="promote" size="sm" onClick={onDateCommit}>Add Date Range</Button>{' '}
              </ModalFooter>
            </Modal>
          </>
        )}
        {chartValues.length === 0 && <p>No Filters Selected</p>}
        {chartValues.map(([value, count]) =>
          <div className='value' key={value}>
            <LabelWithTooltip label={formatDisplayDateRange(value)} parentProps={chartProps} />
            <i className="spacer"></i>
            {shouldTween && <TweenedNumber className='count' value={count} />}
            {!shouldTween && <span className='count'>{humanizeNumber(count)}</span>}
            {!viewOnly && <Button color="link" size="sm" className="remove" id={value} onClick={(ev) => onRemoveDate(ev)}><i className="bi bi-trash"></i></Button>}
          </div>
        )}
      </>
    );
  }

  return <DateRangeWidget {...props} getStartDateFn={getStartDateFn} renderChart={renderChart} />;
}

export default BirthdateRangeWidget;
